/**
 * @generated SignedSource<<9215f6ff5e23b2f9bccbb9fc00111d73>>
 * @relayHash b55f6f64bd82affd6120c9d26d639eb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7a43e3168816e703f8946aac10cc37bbcf0ee4cb9fb2b6c8c7e64e6582df7261

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null | undefined;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null | undefined;
  quickFilterIds?: ReadonlyArray<string> | null | undefined;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null | undefined;
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null | undefined;
  canEnableAggregation?: boolean | null | undefined;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null | undefined;
  fieldId?: string | null | undefined;
  isEnabled?: boolean | null | undefined;
};
export type IssueNavigatorListViewPaginationQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  first?: number | null | undefined;
  id: string;
  isConditionalFormattingEnabled: boolean;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  projectKey?: string | null | undefined;
  projectKeys?: ReadonlyArray<string> | null | undefined;
  saveJQLToUserHistory?: boolean | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  settings?: JiraIssueSearchSettings | null | undefined;
  shouldQueryHasChildren: boolean;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null | undefined;
};
export type IssueNavigatorListViewPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_listViewData">;
  } | null | undefined;
};
export type IssueNavigatorListViewPaginationQuery = {
  response: IssueNavigatorListViewPaginationQuery$data;
  variables: IssueNavigatorListViewPaginationQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": isBulkOpsSelectAllEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isBulkOpsSelectAllEnabled_provider from '@atlassian/jira-relay-provider/src/bulk-ops-select-all.relayprovider';
import isFormulaFieldD1Enabled_provider from '@atlassian/jira-relay-provider/src/frontier-formula-field-d1.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@atlassian/jira-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@atlassian/jira-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker-nin.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isJiraListReduceRerendersEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reduce-rerenders.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isJiraTimelineAnalyticsHarmonizationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-analytics-harmonization.relayprovider';
import isJiraTimelineRollupsTechnicalGateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-rollups-technical-gate.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMimicFlatlistRssWhileUninitialisedEnabled_provider from '@atlassian/jira-relay-provider/src/mimic-flatlist-rss-while-uninitialised.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConditionalFormattingEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKeys"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "saveJQLToUserHistory"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildren"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v16 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v17 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = {
  "kind": "ScalarField",
  "name": "id"
},
v20 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "options",
    "variableName": "options"
  },
  {
    "kind": "Variable",
    "name": "saveJQLToUserHistory",
    "variableName": "saveJQLToUserHistory"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  },
  {
    "kind": "Variable",
    "name": "settings",
    "variableName": "settings"
  },
  {
    "kind": "Variable",
    "name": "viewConfigInput",
    "variableName": "viewConfigInput"
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v22 = {
  "kind": "ScalarField",
  "name": "key"
},
v23 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v24 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v26 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v27 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v19/*: any*/)
  ]
},
v28 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v19/*: any*/)
  ]
},
v29 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    (v19/*: any*/)
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "name"
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "kind": "ScalarField",
  "name": "__id"
},
v33 = {
  "kind": "ScalarField",
  "name": "summary"
},
v34 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "type"
},
v36 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v37 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v38 = {
  "kind": "ScalarField",
  "name": "value"
},
v39 = [
  (v38/*: any*/),
  (v19/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v40 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v41 = {
  "kind": "ClientExtension",
  "selections": [
    (v40/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "message"
},
v43 = [
  (v42/*: any*/)
],
v44 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v45 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v46 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v47 = {
  "kind": "ScalarField",
  "name": "date"
},
v48 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "text"
},
v50 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v19/*: any*/)
  ]
},
v51 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v53 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v54 = {
  "kind": "ScalarField",
  "name": "picture"
},
v55 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v56 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v57 = [
  {
    "kind": "ScalarField",
    "name": "appType"
  }
],
v58 = [
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isUser"
  },
  {
    "kind": "InlineFragment",
    "selections": (v57/*: any*/),
    "type": "AppUser"
  }
],
v59 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v60 = {
  "kind": "ClientExtension",
  "selections": [
    (v32/*: any*/)
  ]
},
v61 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v62 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v63 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v64 = [
  (v19/*: any*/)
],
v65 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v64/*: any*/)
},
v66 = {
  "kind": "ScalarField",
  "name": "href"
},
v67 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v68 = {
  "kind": "InlineFragment",
  "selections": [
    (v47/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v69 = [
  (v18/*: any*/),
  (v37/*: any*/),
  (v68/*: any*/),
  (v19/*: any*/)
],
v70 = [
  (v18/*: any*/),
  (v68/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v64/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v71 = [
  (v18/*: any*/),
  (v19/*: any*/)
],
v72 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v73 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v74 = [
  (v72/*: any*/),
  (v21/*: any*/),
  (v73/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueNavigatorListViewPaginationQuery",
    "selections": [
      {
        "args": (v16/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isConditionalFormattingEnabled",
                "variableName": "isConditionalFormattingEnabled"
              },
              (v17/*: any*/),
              {
                "kind": "Variable",
                "name": "projectKeys",
                "variableName": "projectKeys"
              },
              {
                "kind": "Variable",
                "name": "shouldQueryHasChildren",
                "variableName": "shouldQueryHasChildren"
              }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_listViewData"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v4/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueNavigatorListViewPaginationQuery",
    "selections": [
      {
        "args": (v16/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v20/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  (v19/*: any*/)
                                ]
                              },
                              (v19/*: any*/)
                            ]
                          },
                          (v25/*: any*/),
                          (v29/*: any*/),
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": (v31/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              (v32/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isHighlightedIssueRow"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v33/*: any*/),
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": (v31/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v18/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 500
                          }
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                  },
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      (v36/*: any*/),
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v19/*: any*/),
                                              (v18/*: any*/),
                                              (v37/*: any*/),
                                              (v35/*: any*/),
                                              {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraIssueField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAffectedServiceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedAffectedServicesConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAffectedServiceEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraAffectedService",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "serviceId"
                                                              },
                                                              (v30/*: any*/),
                                                              (v19/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraAffectedServicesField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraCascadingOption",
                                                    "kind": "LinkedField",
                                                    "name": "cascadingOption",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "parentOptionValue",
                                                        "plural": false,
                                                        "selections": (v39/*: any*/)
                                                      },
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "childOptionValue",
                                                        "plural": false,
                                                        "selections": (v39/*: any*/)
                                                      }
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraCascadingSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCmdbObjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedCmdbObjectsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraCmdbObjectEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraCmdbObject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "objectId"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "label"
                                                              },
                                                              {
                                                                "concreteType": "JiraCmdbAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaClientConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "clientId"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "fileId"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "mediaBaseUrl"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "mediaJwtToken"
                                                                      }
                                                                    ]
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "url48"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": (v43/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCMDBField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "args": (v44/*: any*/),
                                                    "concreteType": "JiraComponentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedComponentsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v45/*: any*/),
                                                              (v46/*: any*/),
                                                              (v19/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraComponentsField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v47/*: any*/),
                                                  (v30/*: any*/),
                                                  (v48/*: any*/),
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraDatePickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "dateTime"
                                                  },
                                                  (v30/*: any*/),
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraDateTimePickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraEpic",
                                                    "kind": "LinkedField",
                                                    "name": "epic",
                                                    "plural": false,
                                                    "selections": [
                                                      (v22/*: any*/),
                                                      (v33/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "color"
                                                      },
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraEpicLinkField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "renderedFieldHtml"
                                                  }
                                                ],
                                                "type": "JiraFallbackField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v49/*: any*/),
                                                  (v30/*: any*/),
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatusCategory",
                                                    "kind": "LinkedField",
                                                    "name": "statusCategory",
                                                    "plural": false,
                                                    "selections": [
                                                      (v30/*: any*/),
                                                      (v26/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraStatusCategoryField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": [
                                                      (v30/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "statusId"
                                                      },
                                                      (v27/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraStatusField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": (v44/*: any*/),
                                                    "concreteType": "JiraLabelConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedLabelsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      (v36/*: any*/),
                                                      {
                                                        "concreteType": "JiraLabelEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v30/*: any*/),
                                                              (v50/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                  },
                                                  (v30/*: any*/),
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraLabelsField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v34/*: any*/),
                                                      (v30/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssueTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "parentIssue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v22/*: any*/),
                                                      {
                                                        "concreteType": "JiraColorField",
                                                        "kind": "LinkedField",
                                                        "name": "issueColorField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v50/*: any*/),
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              (v51/*: any*/),
                                                              (v30/*: any*/),
                                                              (v19/*: any*/)
                                                            ]
                                                          },
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v49/*: any*/),
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      (v19/*: any*/),
                                                      (v23/*: any*/),
                                                      (v52/*: any*/),
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                          {
                                                            "args": [
                                                              {
                                                                "kind": "Literal",
                                                                "name": "ids",
                                                                "value": [
                                                                  "issuetype",
                                                                  "project",
                                                                  "summary",
                                                                  "status"
                                                                ]
                                                              }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v18/*: any*/),
                                                                      (v19/*: any*/),
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v37/*: any*/),
                                                                          (v49/*: any*/)
                                                                        ],
                                                                        "type": "JiraSingleLineTextField"
                                                                      },
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v37/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v19/*: any*/),
                                                                              (v53/*: any*/),
                                                                              (v30/*: any*/),
                                                                              (v51/*: any*/),
                                                                              (v24/*: any*/)
                                                                            ]
                                                                          }
                                                                        ],
                                                                        "type": "JiraIssueTypeField"
                                                                      },
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v37/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v19/*: any*/),
                                                                              {
                                                                                "concreteType": "JiraStatusCategory",
                                                                                "kind": "LinkedField",
                                                                                "name": "statusCategory",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v19/*: any*/),
                                                                                  (v26/*: any*/)
                                                                                ]
                                                                              }
                                                                            ]
                                                                          }
                                                                        ],
                                                                        "type": "JiraStatusField"
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v37/*: any*/),
                                                              {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v53/*: any*/),
                                                                  (v24/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v37/*: any*/)
                                                            ]
                                                          },
                                                          {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v37/*: any*/),
                                                              (v28/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v30/*: any*/),
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraParentIssueField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                      (v30/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "iconUrl"
                                                      },
                                                      (v19/*: any*/)
                                                    ]
                                                  },
                                                  (v30/*: any*/),
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraPriorityField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      (v30/*: any*/),
                                                      (v22/*: any*/),
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                          }
                                                        ]
                                                      },
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraProjectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraResolution",
                                                    "kind": "LinkedField",
                                                    "name": "resolution",
                                                    "plural": false,
                                                    "selections": [
                                                      (v30/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraResolutionField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSprintConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedSprintsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSprintEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "sprintId"
                                                              },
                                                              (v30/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "state"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "endDate"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v30/*: any*/),
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraSprintField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      (v18/*: any*/),
                                                      (v30/*: any*/),
                                                      (v54/*: any*/),
                                                      (v55/*: any*/),
                                                      (v19/*: any*/),
                                                      (v56/*: any*/),
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": (v58/*: any*/)
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": (v57/*: any*/)
                                                          }
                                                        ],
                                                        "type": "AppUser"
                                                      },
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": (v58/*: any*/)
                                                      }
                                                    ]
                                                  },
                                                  (v48/*: any*/),
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraSingleSelectUserPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraRichText",
                                                    "kind": "LinkedField",
                                                    "name": "richText",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraADF",
                                                        "kind": "LinkedField",
                                                        "name": "adfValue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                            "kind": "LinkedField",
                                                            "name": "convertedPlainText",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "plainText"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraRichTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraServiceManagementRequestType",
                                                    "kind": "LinkedField",
                                                    "name": "requestType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v30/*: any*/),
                                                      (v51/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraServiceManagementRequestTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "first",
                                                        "value": 1
                                                      }
                                                    ],
                                                    "concreteType": "JiraIssueLinkConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueLinkConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      (v36/*: any*/),
                                                      {
                                                        "concreteType": "JiraIssueLinkEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "issue",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v52/*: any*/),
                                                                  (v22/*: any*/),
                                                                  {
                                                                    "args": [
                                                                      {
                                                                        "kind": "Literal",
                                                                        "name": "ids",
                                                                        "value": [
                                                                          "statusCategory"
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v18/*: any*/),
                                                                              {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                  (v27/*: any*/)
                                                                                ],
                                                                                "type": "JiraStatusCategoryField"
                                                                              },
                                                                              (v19/*: any*/)
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                  },
                                                                  {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                      (v25/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v19/*: any*/)
                                                                ]
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "relationName"
                                                              },
                                                              (v19/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "issueLinkConnection(first:1)"
                                                  }
                                                ],
                                                "type": "JiraIssueLinkField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isStoryPointField"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                  },
                                                  (v30/*: any*/),
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraNumberFieldFormatConfig",
                                                        "kind": "LinkedField",
                                                        "name": "formatConfig",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "formatStyle"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "formatUnit"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraNumberField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCommentSummary",
                                                    "kind": "LinkedField",
                                                    "name": "commentSummary",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "canAddComment"
                                                      },
                                                      (v36/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCommentSummaryField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "uri"
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraUrlField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "fieldOption",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v50/*: any*/),
                                                      (v19/*: any*/),
                                                      (v59/*: any*/)
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraSingleSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v38/*: any*/),
                                                              (v59/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraMultipleSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v38/*: any*/)
                                                            ]
                                                          },
                                                          (v60/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraCheckboxesField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraUserConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedUsersConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraUserEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v18/*: any*/),
                                                              (v56/*: any*/),
                                                              (v30/*: any*/),
                                                              (v54/*: any*/),
                                                              (v19/*: any*/),
                                                              (v55/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "email"
                                                                  }
                                                                ],
                                                                "type": "AtlassianAccountUser"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraMultipleSelectUserPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraTeamView",
                                                    "kind": "LinkedField",
                                                    "name": "selectedTeam",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "jiraSuppliedId"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "jiraSuppliedName"
                                                      }
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraTeamViewField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraTimeTrackingField",
                                                            "kind": "LinkedField",
                                                            "name": "timeTrackingField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v61/*: any*/),
                                                              (v62/*: any*/),
                                                              (v37/*: any*/),
                                                              (v30/*: any*/),
                                                              (v35/*: any*/),
                                                              (v41/*: any*/)
                                                            ]
                                                          },
                                                          (v19/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraOriginalTimeEstimateField"
                                                  }
                                                ]
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraTimeTrackingField",
                                                            "kind": "LinkedField",
                                                            "name": "timeTrackingField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v61/*: any*/),
                                                              (v62/*: any*/),
                                                              (v19/*: any*/),
                                                              (v37/*: any*/),
                                                              (v30/*: any*/),
                                                              (v35/*: any*/)
                                                            ]
                                                          },
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      (v41/*: any*/)
                                                    ],
                                                    "type": "JiraOriginalTimeEstimateField"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOption",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": "label",
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                      },
                                                      (v19/*: any*/),
                                                      (v45/*: any*/)
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraRadioSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "args": (v44/*: any*/),
                                                    "concreteType": "JiraVersionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedVersionsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v30/*: any*/),
                                                              (v45/*: any*/),
                                                              (v46/*: any*/),
                                                              (v63/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraMultipleVersionPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  (v65/*: any*/),
                                                  {
                                                    "args": (v44/*: any*/),
                                                    "concreteType": "JiraGoalConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedGoals",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGoalEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraGoal",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v22/*: any*/),
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  (v30/*: any*/),
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v60/*: any*/)
                                                    ],
                                                    "storageKey": "selectedGoals(first:1000)"
                                                  },
                                                  {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                      (v32/*: any*/),
                                                      (v40/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraGoalsField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v30/*: any*/),
                                                      (v65/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isLinkEditable"
                                                      },
                                                      {
                                                        "concreteType": "JiraTownsquareProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          {
                                                            "alias": "atlasProjectName",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                          },
                                                          {
                                                            "alias": "atlasProjectKey",
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "privateProject"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "hasPermission"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "isWorkspaceActive"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "iconName"
                                                          }
                                                        ]
                                                      },
                                                      (v41/*: any*/)
                                                    ],
                                                    "type": "JiraTownsquareProjectField"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "args": (v44/*: any*/),
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                    "kind": "LinkedField",
                                                    "name": "confluenceRemoteIssueLinks",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v66/*: any*/),
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "pageContent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v18/*: any*/),
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v66/*: any*/)
                                                                        ],
                                                                        "type": "JiraConfluencePageContentDetails"
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v36/*: any*/)
                                                    ],
                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraConfluenceRemoteIssueLinksField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraGroupConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedGroupsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGroupEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v30/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "groupId"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v41/*: any*/)
                                                ],
                                                "type": "JiraMultipleGroupPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraFlag",
                                                    "kind": "LinkedField",
                                                    "name": "flag",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isFlagged"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraFlagField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraWatch",
                                                    "kind": "LinkedField",
                                                    "name": "watch",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "count"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isWatching"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraWatchesField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v23/*: any*/),
                                                              {
                                                                "concreteType": "JiraIssueTypeField",
                                                                "kind": "LinkedField",
                                                                "name": "issueTypeField",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v30/*: any*/),
                                                                      (v24/*: any*/),
                                                                      (v19/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v19/*: any*/)
                                                                ]
                                                              },
                                                              {
                                                                "concreteType": "JiraParentIssueField",
                                                                "kind": "LinkedField",
                                                                "name": "parentIssueField",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v23/*: any*/),
                                                                      (v22/*: any*/),
                                                                      (v19/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v19/*: any*/)
                                                                ]
                                                              },
                                                              (v22/*: any*/),
                                                              (v29/*: any*/),
                                                              {
                                                                "concreteType": "JiraSingleSelectUserPickerField",
                                                                "kind": "LinkedField",
                                                                "name": "assigneeField",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v18/*: any*/),
                                                                      (v54/*: any*/),
                                                                      (v19/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v19/*: any*/)
                                                                ]
                                                              },
                                                              {
                                                                "args": (v67/*: any*/),
                                                                "kind": "LinkedField",
                                                                "name": "startDateViewField",
                                                                "plural": false,
                                                                "selections": (v69/*: any*/),
                                                                "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                              },
                                                              {
                                                                "args": (v67/*: any*/),
                                                                "kind": "LinkedField",
                                                                "name": "endDateViewField",
                                                                "plural": false,
                                                                "selections": (v69/*: any*/),
                                                                "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "aggregatedStartDateViewField",
                                                                    "plural": false,
                                                                    "selections": (v70/*: any*/)
                                                                  },
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "aggregatedEndDateViewField",
                                                                    "plural": false,
                                                                    "selections": (v70/*: any*/)
                                                                  }
                                                                ],
                                                                "type": "JiraAggregatedTimelineField"
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraTimelineVirtualField",
                                                        "abstractKey": "__isJiraTimelineVirtualField"
                                                      }
                                                    ],
                                                    "type": "JiraAggregatedTimelineField"
                                                  }
                                                ]
                                              },
                                              (v60/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v60/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "isConditionalFormattingEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "args": (v44/*: any*/),
                                                        "concreteType": "JiraComponentConnection",
                                                        "kind": "LinkedField",
                                                        "name": "selectedComponentsConnection",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraComponentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraComponent",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "componentId"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                      }
                                                    ],
                                                    "type": "JiraComponentsField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "priorityId"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraProjectField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "version",
                                                        "plural": false,
                                                        "selections": [
                                                          (v63/*: any*/),
                                                          (v19/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraSingleVersionPickerField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                          (v53/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "selectedValue",
                                                        "plural": false,
                                                        "selections": (v71/*: any*/)
                                                      }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSelectableValueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "selectedValues",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraSelectableValueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v71/*: any*/)
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraMultipleSelectField"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldSets(first:500)"
                      },
                      {
                        "condition": "shouldQueryHasChildren",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "filterByProjectKeys",
                                "variableName": "projectKeys"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "hasChildren"
                          },
                          {
                            "args": [
                              (v17/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "canHaveChildIssues"
                          }
                        ]
                      },
                      (v60/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasPreviousPage"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraIssueNavigatorPageInfo",
                    "kind": "LinkedField",
                    "name": "issueNavigatorPageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastIssuePosition"
                      }
                    ]
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                      }
                    ],
                    "concreteType": "JiraPageCursors",
                    "kind": "LinkedField",
                    "name": "pageCursors",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": (v74/*: any*/)
                      },
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": (v74/*: any*/)
                      },
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v72/*: any*/),
                          (v73/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "pageCursors(maxCursors:7)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalIssueSearchResultCount"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "issueSearchError",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "messages"
                          }
                        ],
                        "type": "JiraInvalidJqlError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "errorType"
                          }
                        ],
                        "type": "JiraInvalidSyntaxError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v43/*: any*/),
                        "type": "JiraServerError"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isCappingIssueSearchResult"
                  },
                  (v60/*: any*/),
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v20/*: any*/),
                "filters": [
                  "issueSearchInput"
                ],
                "handle": "connection",
                "key": "IssueNavigatorListViewPagination__issues",
                "kind": "LinkedHandle",
                "name": "issues"
              }
            ],
            "type": "JiraListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7a43e3168816e703f8946aac10cc37bbcf0ee4cb9fb2b6c8c7e64e6582df7261",
    "metadata": {},
    "name": "IssueNavigatorListViewPaginationQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": isBulkOpsSelectAllEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider
    }
  }
};
})();

(node as any).hash = "22a2814eefaacda9ce108e2fd8c70777";

export default node;
